 // Currency
/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */
// const moneyFormat = '$';
/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param  {String} format - shop money_format setting
 * @return {String} value - formatted value
 */
function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;

  function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
    const centsAmount = parts[1] ? decimal + parts[1] : '';
    return dollarsAmount + centsAmount;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
};

$(function() {
  $('.shopify-currency-form select').on('change', function() {
    $(this)
      .parents('form')
      .submit();
  });
});

$(function() {
    // Hero slider
    var mySwiper = new Swiper('.hero-section .swiper-container', {
      loop: true,
      pagination: {
        el: '.hero-section .swiper-pagination',
        clickable: true,
      },
    });
    // Category slider
    // var mySwiper = new Swiper('.category-section .swiper-container', {
    //   loop: true,
    //   navigation: {
    //     nextEl: '.category-section .swiper-button-next',
    //     prevEl: '.category-section .swiper-button-prev',
    //   },
    //   slidesPerView: 4,
    //   breakpoints: {
    //     767: {
    //       slidesPerView: 1
    //     },
    //     1023: {
    //       slidesPerView: 2
    //     },
    //     1599: {
    //       slidesPerView: 3
    //     }
    //   }
    // });
    // Collection slider
    var mySwiper = new Swiper('.collection-section .swiper-container', {
      loop: true,
      pagination: {
        el: '.collection-section .swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.collection-section .swiper-button-next',
        prevEl: '.collection-section .swiper-button-prev',
      },
      slidesPerView: 4,
      breakpoints: {
        767: {
          slidesPerView: 1
        },
        1023: {
          slidesPerView: 2
        },
        1599: {
          slidesPerView: 3
        }
      }
    });

    // Related items  slider
    var mySwiper = new Swiper('.related-items-carousel', {
      loop: false,
      pagination: {
        el: '',
        clickable: false,
      },
      navigation: {
        nextEl: '.related-items-carousel .swiper-button-next',
        prevEl: '.related-items-carousel .swiper-button-prev',
      },
      slidesPerView: 4,
      spaceBetween: 30,
      breakpoints: {
        767: {
          pagination: {
            el: '',
          },
          navigation: {
            nextEl: '.related-items-carousel .swiper-button-next',
            prevEl: '.related-items-carousel .swiper-button-prev',
          },
          slidesPerView: 1,
        },
        1023: {
          slidesPerView: 3
        },
      }
    });
  });

// Recently Viewed slider
var recentlyViewedSwiper = new Swiper('.recently-viewed-items-carousel', {
  loop: false,
  pagination: {
    el: '',
    clickable: false,
  },
  navigation: {
    nextEl: '.recently-viewed-items-carousel .swiper-button-next',
    prevEl: '.recently-viewed-items-carousel .swiper-button-prev',
  },
  slidesPerView: 4,
  spaceBetween: 30,
  breakpoints: {
    767: {
      pagination: {
        el: '',
      },
      navigation: {
        nextEl: '.recently-viewed-items-carousel .swiper-button-next',
        prevEl: '.recently-viewed-items-carousel .swiper-button-prev',
      },
      slidesPerView: 1,
    },
    1023: {
      slidesPerView: 3
    },
  }
});
$(function() {
  $(".navbar-toggler, #navigation-close-btn, #menu-overlay").on("click", function(e) {
    $("#navigation, #menu-overlay").toggleClass("show");
    $("html,body").toggleClass("no-scroll");
    e.preventDefault();
  });
});
$(function() {
  $(".search-icon, .search-close-btn,.search-btn-sm, #search-overlay").on("click", function(e) {
    $(".search-wrapper, #search-overlay").toggleClass("show");
    $("html,body").toggleClass("no-scroll");
    e.preventDefault();
  });
});
$(function() {
  $("#cart-overlay, .cart-icon, .cart-close-btn").on("click", function(e) {
    $(".cart-sidebar, #cart-overlay").toggleClass("show");
    $("body,html").toggleClass("no-scroll");
    e.preventDefault();
  });
});
$(function() {
  $(".sidebar-title").on("click", function() {
    $("#sorting-accordion").toggleClass("show");
  });
});
$(function() {
  $("#navbar").sticky({
    topSpacing: 0,
    zIndex: 99999
  });
});
$(function() {
  AOS.init({
    duration: 1000,
  });
});
$(function() {
  $('#product-img-carousel').lightGallery({
    selector: '.swiper-slide',
    loop: false,
    download: false,
    thumbnail: false,
    zoom: false,
    share: false,
    fullScreen: false,
    autoplayControls: false
  });
});


// Product card height
// $(function() {
//   var PCWidth = $(".category-section .product-card").width();
//   $(".category-section .product-card .product-img img").height(PCWidth);
//   var PCWidthSM = $(".category-section .mobile-view .product-card").width();
//   $(".category-section .mobile-view .product-card .product-img img").height(PCWidthSM);
// });

// Currency Picker
$(function() {
	$('.currency_selector_desktop select[name=currency]').multiselect();
})


// Justified Gallery
$('.gallery-container').justifiedGallery({
    rowHeight : 250,
    lastRow : 'nojustify',
    margins : 15,
});

// $('.gallery-container').justifiedGallery('destroy');


var bijoux = window.bijoux || {};
bijoux.init = function() {
  var body = $('body');
  if (body.hasClass('product')) {
    bijoux.product();
  }
  if (body.hasClass('collection')) {
    bijoux.collectionTemplate();
  }
}
bijoux.productThumbSlider = new Swiper('#product-thumb-carousel', {
  loop: false,
  direction: 'vertical',
  slidesPerView: 5,
  spaceBetween: 20,
  freeMode: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
});
bijoux.productImageSlider = new Swiper('#product-img-carousel', {
  spaceBetween: 10,
  breakpoints: {
    1023: {
      pagination: {
        el: '#product-img-carousel .swiper-pagination',
      }
    }
  },
  thumbs: {
    swiper: bijoux.productThumbSlider
  }
});
bijoux.product = function() {
  // Initializing Recently Viewed Items
  bijoux.addingToRvStorage();
  var formElement = document.querySelector('[data-product-form]');
  var productHandle = formElement.dataset.productHandle;
  var priceEl = document.querySelector('[data-price-conainer]');
  var atcBtn = formElement.querySelector('[add-to-cart-btn]');
  var url = '/products/' + productHandle + '.js';
  $.get(url, function(productJson) {
    var productObj = JSON.parse(productJson);
    new Shopify.theme.productForm.ProductForm(formElement, productObj, {
      onOptionChange,
      onFormSubmit
    });

  })

  function onOptionChange(event) {
    var variant = event.dataset.variant;
    var variantPrice = formatMoney(variant.price);
    if (variant === null) {
      // The combination of selected options does not have a matching variant
      priceEl.innerText = variantPrice;
      atcBtn.setAttribute('disabled', 'disabled');
      history.pushState({}, variant.name, '?variant=' + variant.id);
      if (variant.featured_image) {
        bijoux.productImageSlider.slideTo(variant.featured_image.position - 1);
      }
    } else if (variant && !variant.available) {
      // The combination of selected options has a matching variant but it is
      // currently unavailable
      priceEl.innerText = variantPrice;
      atcBtn.setAttribute('disabled', 'disabled');
      history.pushState({}, variant.name, '?variant=' + variant.id);
      if (variant.featured_image) {
        bijoux.productImageSlider.slideTo(variant.featured_image.position - 1);
      }
    } else if (variant && variant.available) {
      // The combination of selected options has a matching variant and it is
      // available
      priceEl.innerText = variantPrice;
      atcBtn.removeAttribute('disabled');
      history.pushState({}, variant.name, '?variant=' + variant.id);
      if (variant.featured_image) {
        bijoux.productImageSlider.slideTo(variant.featured_image.position - 1);
      }
      if (variant.inventory_quantity < 10) {
        document.querySelector('.stock-availability').innerHTML = '<p>Only ' + variant.inventory_quantity + ' pieces in stock!</p>';
      } else {
        document.querySelector('.stock-availability').innerHTML = '';
      }
    }
  }

  // Form add to cart
  function onFormSubmit(event) {
    event.preventDefault();
    console.log(event.dataset);

    var formData = {
      quantity: event.dataset.quantity,
      id: event.dataset.variant.id,
      properties: event.dataset.properties
    };
    bijoux.cartInit.addTocart(formData, function(data) {
      console.log(data);
      bijoux.cartInit.buildCart(function(data) {
        $(".cart-sidebar, #cart-overlay").toggleClass("show");
        $("body").toggleClass("no-scroll");
      });
    });
  }
}

bijoux.cartInit = (function() {
  var errEl = $('.cart-error-alert');
  var addTocart = function(postData, cb) {
    console.log(postData);
    $.ajax({
      method: 'post',
      url: '/cart/add.js',
      data: postData,
      dataType: 'JSON',
      success: function(data) {
        errEl.html('');
        if (cb) cb(data);
      },
      error: function(err) {
        if (err.responseJSON.status === 422) {
          errEl.html(err.responseJSON.description);
        } else {
          errEl.html('Something Went Wrong!');
        }
      }
    })
  };

  var buildCart = function(cb) {
    $.get('/cart?view=drawer', function(data) {
      $('.cart-counter').html($(data).filter('.cart-counter').html());
      $('#drawer-product-list').html($(data).filter('.drawer-product-list').html());
      $('#cart-drawer-footer').html($(data).filter('.cart-drawer-footer').html());

      if (cb) cb(data);
    })
  };

  var updateCartEvent = (function() {
    $(document).on('click', '.qty-selector, .remove-cart-item', function(event) {
      var cartLineItem = $(this).parents('[data-cart-line-item]');
      var lineItemKey = cartLineItem.data('cart-line-item');
      var quantitySelector = cartLineItem.find('.cart-quantity-field');
      var currentQuantity = parseInt(quantitySelector.val());
      var cartItemError = cartLineItem.find('.cart-item-update-error');

      if ($(this).hasClass('quantity-increase')) {
        updateCart(lineItemKey, currentQuantity+1, function(data) {
          buildCart();
        }, function(err) {
          if (err.responseJSON.status === 422) {
            cartItemError.html(err.responseJSON.description);
          } else {
            cartItemError.html('Something Went Wrong!');
          }
        })
      } else if ($(this).hasClass('quantity-decrease')) {
        updateCart(lineItemKey, currentQuantity-1, function(data) {
            buildCart();
        }, function(err) {
          if (err.responseJSON.status === 422) {
            cartItemError.html(err.responseJSON.description);
          } else {
            cartItemError.html('Something Went Wrong!');
          }
        })
      } else if ($(this).hasClass('remove-cart-item')) {
        updateCart(lineItemKey, 0, function(data) {
          buildCart();
        }, function(err) {
          if (err.responseJSON.status === 422) {
            cartItemError.html(err.responseJSON.description);
          } else {
            cartItemError.html('Something Went Wrong!');
          }
        })
      }

    });
  })();

  var updateCart = function(lineItemKey, quantity, successCb, errCb) {
    var updateData = {
      'quantity': quantity,
      'id': lineItemKey
    };
    $.ajax({
      method: 'POST',
      url: '/cart/change.js',
      data: updateData,
      success: function(data) {
        if(successCb) successCb(data);
      },
      error: function(err) {
        if(errCb) errCb(err);
      }
    })
  };

  return {
    addTocart,
    buildCart
  }
})();

bijoux.addingToRvStorage = function() {
  var key = 'recentlyViewedItemsBijouxSerendipity';
  if (!localStorage.getItem(key)) {
    localStorage.setItem(key, '[]');
  }
  var parsedItems = JSON.parse(localStorage.getItem(key));
  var currentProductJsonEl = document.querySelector('[data-product-json]');
  console.log(parsedItems);
  if (currentProductJsonEl) {
    var currenctProductObj = JSON.parse(currentProductJsonEl.innerHTML);
    if (currenctProductObj) {
      var saveditems = parsedItems.filter(function(item) {
        return item.id != currenctProductObj.id
      })
      bijoux.loadingRVonProductPage(saveditems);
      var newItems = saveditems;
      newItems.unshift(currenctProductObj);
      if (newItems.length > 12) {
        newItems.length = 12;
      }
      var newItemsString = JSON.stringify(newItems);
      localStorage.setItem(key, newItemsString);
    }
  }
};
bijoux.loadingRVonProductPage = function(savedItems) {
  if (!savedItems && localStorage.getItem('recentlyViewedItemsBijouxSerendipity')) {
    var savedItems = JSON.parse(localStorage.getItem('recentlyViewedItemsBijouxSerendipity'));
  }
  var rvRenderSection = document.querySelector('[data-rv-items-section]');
  var rvItemsContainer = rvRenderSection.querySelector('[data-rv-items-container]');
  console.log(savedItems);
  if (savedItems && savedItems != null && savedItems.length > 0) {
    if (rvItemsContainer) {
      savedItems.forEach(function(item) {
        console.log(item);
        rvItemsContainer.innerHTML += '<div class="swiper-slide">' + '<div class="product-card px-2">' + '<div class="product-img mb-3">' + '<a href="/products/' + item.handle + '"><img src="' + item.featured_image + '" alt="" class="img-fluid"></a>' + '<a href="/products/' + item.handle + '"><img src="' + item.images[1] + '" alt="" class="img-fluid hover-img"></a>' + '</div>' + '<div class="product-content">' + '<h6 class="text-center text-sm-left">' + item.title + '</h6>' + '</div>' + '</div>' + '</div>';
      });
      recentlyViewedSwiper.updateSlides();
    }
  } else {
    rvRenderSection.style.display = 'none';
  }
}
bijoux.collectionTemplate = function() {
  // Recently Viewed Items
  bijoux.loadingRVonProductPage();
  // Infinite scroll on click
  bijoux.infiniteScroll();
  // Filters
  if (window.innerWidth > 992) {
    $('[name^=filter-radio]').on('change', function() {
      bijoux.filter();
    })
  } else {
    $('#mobileFilterTrigger').on('click', function() {
      bijoux.filter();
      $("#sorting-accordion").toggleClass("show");
    })
  }
  // Resettings filters
  $('.reset-filter').on('click', function() {
    bijoux.filterReset();
  })
}

bijoux.infiniteScroll = function() {
  var endlessScroll = new Ajaxinate({
    container: '#AjaxinateLoop',
    pagination: '#AjaxinatePagination',
    method: 'click'
  });
}

bijoux.filter = function() {
  var filterSections = $('[data-filter-section-name]');
  var query = '';
  var productContainer = $('#filteredProductsContainer');
  filterSections.each(function(index) {
    var filterInput = '[name=' + $(this).data('filter-section-name') + ']:checked';
    var filterData = $(this).find(filterInput).val();
    if (filterData) {
      query += filterData;
      filterData && filterSections.length == index + 1 ? query += '' : query += '+';
    }
  })

  if (query) {
    $.get('/collections/all/' + query + '?view=filter', function(data) {

      if ($(data).find('.product-card').length > 0) {
        productContainer.html(data);
      } else {
        productContainer.html(
          '<div class="filter-empty-container text-center">' +
          '<h4>No Item Found.</h4>' +
          '<button class="reset-filter btn btn-black" >RESET</button>' +
          '</div>'
        ).addClass('d-flex justify-content-center align-items-center');
      }

      var filterAjaxinate = new Ajaxinate({
        container: '#AjaxinateLoopFilter',
        pagination: '#AjaxinatePaginationFilter',
        method: 'scroll'
      })

    })
  }
}

bijoux.filterReset = function() {
  var productContainer = $('#filteredProductsContainer');

  $('[name^=filter-radio]:checked').prop('checked', false).trigger('change');

  $.get('/collections/all/?view=filter', function(data) {
    console.log(data);
    if ($(data).find('.product-card').length > 0) {
      productContainer.html(data);
    } else {
      productContainer.html(
        '<div class="filter-empty-container text-center">' +
        '<h4>No Item Found.</h4>' +
        '<button class="reset-filter btn btn-black" >RESET</button>' +
        '</div>'
      ).addClass('d-flex justify-content-center align-items-center');
    }

    var filterAjaxinate = new Ajaxinate({
      container: '#AjaxinateLoopFilter',
      pagination: '#AjaxinatePaginationFilter',
      method: 'scroll'
    })

  })
}

bijoux.featuredCollection = function() {
  // Category slider

  var _initSwiper = function(container, id) {

    var swiperContainer = container.querySelector('.swiper-container');
    var swiperNav = {
      next: '#swiper-button-next-' + id,
      prev: '#swiper-button-prev-' + id
    }

    var initSwiper = new Swiper(swiperContainer, {
      loop: false,
      navigation: {
        nextEl: swiperNav.next,
        prevEl: swiperNav.prev,
      },
      slidesPerView: 4,
      breakpoints: {
        767: {
          slidesPerView: 1
        },
        1023: {
          slidesPerView: 2
        },
        1599: {
          slidesPerView: 3
        }
      },
      on: {
        init: function() {
          _fixHeight(container);
        }
      }
    });

    return initSwiper;
  }

  var _fixHeight = function(container) {
    var PCWidth = container.querySelector(".product-card").offsetWidth;
    container.querySelectorAll(".product-card").forEach(function(el) {
    	el.style.height = PCWidth + 'px';
    })
  }

  var featuredCollecction = {
    publicMethod: function() {
      // Custom public section method
    },
    onLoad: function() {
      // Do something when a section instance is loaded
      console.log('slider-loaded');
      // featuredCollecctionSwiper.update();
      // this.fixHeight = _fixHeight(this.container, this.id);
      this.featuredCollectionSwiper = _initSwiper(this.container, this.id);
    },
    onUnload: function() {
      // Do something when a section instance is unloaded
      console.log('slider-unloaded');
      this.featuredCollectionSwiper.destroy();
    },
    onBlockSelect: function() {
      // Do something when a section block is selected
      console.log('slider-block-loaded');
      this.featuredCollectionSwiper.updateSlides();
    },
    // Shortcut function called when a section block is deselected by the Theme Editor 'shopify:block:deselect' event.
    onBlockDeselect: function() {
      // Do something when a section block is deselected
      console.log('slider-block-unloaded');
      this.featuredCollectionSwiper.updateSlides();
    }
  }

  return featuredCollecction;
};

bijoux.newArrival = function() {

  var initNewArrivalSwiper = function(container, id) {

    var newArrivalSwiperContainer = container.querySelector('.new-arrival-slider');
    var newArrivalSwiperBtns = {
      next: '#swiper-button-next-'+id,
      prev: '#swiper-button-prev-'+id
    }

  // New arrival slider
    var newArrivalSwiper = new Swiper(newArrivalSwiperContainer, {
      simulateTouch: false,
      navigation: {
        nextEl: newArrivalSwiperBtns.next,
        prevEl: newArrivalSwiperBtns.prev
      },
      breakpoints: {
        767: {
          pagination: {
            el: '',
          },
          navigation: {
            nextEl: '',
            prevEl: '',
          },
        }
      }
    });

    return newArrivalSwiper;
  }

  var initNewArrivalProductSwiper = function(container, id) {
      var newArivalProductSwiperWrapper = container.querySelectorAll('.sp-slider');


      newArivalProductSwiperWrapper.forEach(function(item) {
        new Swiper(item, {
          effect: 'fade',
          nested: true,
          simulateTouch: false,
          pagination: {
            el: '.new-arrival-section .swiper-pagination.sp-pagi,.new-arrival-section .pulsing-buttons-wrapper',
            clickable: true,
          },
          navigation: {
            nextEl: '',
            prevEl: '',
          },
        });
      })
  }

  var newArrival = {
    publicMethod: function() {
      // Custom public section method
    },
    onLoad: function() {
      // Do something when a section instance is loaded
      console.log('slider-loaded');
      // featuredCollecctionSwiper.update();
      // this.fixHeight = _fixHeight(this.container, this.id);
      this.initNewArrivalSwiper = initNewArrivalSwiper(this.container, this.id);
      initNewArrivalProductSwiper(this.container);
    },
    onUnload: function() {
      // Do something when a section instance is unloaded
      console.log('slider-unloaded');
      // this.initNewArrivalSwiper.destroy();
    },
    onBlockSelect: function() {
      // Do something when a section block is selected
      console.log('slider-block-loaded');
      this.initNewArrivalSwiper.updateSlides();
      initNewArrivalProductSwiper(this.container);
    },
    // Shortcut function called when a section block is deselected by the Theme Editor 'shopify:block:deselect' event.
    onBlockDeselect: function() {
      // Do something when a section block is deselected
      console.log('slider-block-unloaded');
      this.initNewArrivalSwiper.updateSlides();
      initNewArrivalProductSwiper(this.container);
    }
  }

  return newArrival;
};

$(document).ready(function() {
  bijoux.init();

  var sections = Shopify.theme.sections;

  sections.register('featured-collection', bijoux.featuredCollection());
  sections.register('shop-the-look', bijoux.newArrival());

  sections.load('*');
});


